"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var saveEnquiryForm_1 = require("../graphql/mutations/saveEnquiryForm");
var client_1 = require("@apollo/client");
var constants_1 = require("../../../../common/constants/constants");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var useNavigationSteps_1 = require("../../../checkout3/common/hooks/useNavigationSteps");
var useDxpDigitalAssignmentEntryEvent_1 = require("../../../common/hooks/useDxpDigitalAssignmentEntryEvent");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var useEnquiryFormSubmit = function (handleAsyncValidationErrors, token, goToNextStep, stateId) {
    var _a = client_1.useMutation(saveEnquiryForm_1.default.SAVE_FORM), saveForm = _a[0], _b = _a[1], loading = _b.loading, error = _b.error;
    var setDeal = useCheckoutContext_1.default().setDeal;
    var _c = useNavigationSteps_1.default(), steps = _c.steps, activeStep = _c.activeStep;
    var callDxpDigitalAssignmentEntryEvent = useDxpDigitalAssignmentEntryEvent_1.default().callDxpDigitalAssignmentEntryEvent;
    var _d = usePlatformConfig_1.default().platformConfig, dataLayer = _d.platformFeatures.dataLayer, fetchBreakdownJsonSchema = _d.fetchBreakdownJsonSchema;
    var removeTradeIn = react_1.useCallback(function (formData) {
        delete formData.tradeIn;
        formData.tradeIn = {};
        formData.tradeIn.tradeInCheckbox = false;
    }, []);
    react_1.useEffect(function () {
        if (error) {
            handleAsyncValidationErrors(error);
        }
    }, [error]);
    var onSubmit = react_1.useCallback(function (_a) {
        var formData = _a.formData;
        var _b;
        (_b = window.grecaptcha) === null || _b === void 0 ? void 0 : _b.ready(function () {
            window.grecaptcha
                .execute(constants_1.default.RECAPTCHA_SITE_KEY, { action: 'submit' })
                .then(function (captchaToken) { return __awaiter(void 0, void 0, void 0, function () {
                var deal;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!((_b = (_a = formData) === null || _a === void 0 ? void 0 : _a.tradeIn) === null || _b === void 0 ? void 0 : _b.tradeInCheckbox)) {
                                removeTradeIn(formData);
                            }
                            return [4 /*yield*/, saveForm({
                                    variables: {
                                        dealId: token,
                                        state: stateId,
                                        captchaToken: captchaToken,
                                        data: { formData: JSON.stringify(formData) },
                                        dataLayer: !!dataLayer,
                                        fetchBreakdownJsonSchema: (fetchBreakdownJsonSchema !== null && fetchBreakdownJsonSchema !== void 0 ? fetchBreakdownJsonSchema : true),
                                    },
                                })];
                        case 1:
                            deal = _c.sent();
                            if (!deal.errors) {
                                setDeal(deal.data.saveEnquiryForm);
                                callDxpDigitalAssignmentEntryEvent(deal.data.saveEnquiryForm, steps, activeStep.index + 1, {
                                    pageName: steps[activeStep.index + 1].pathname,
                                    pageLocation: steps[activeStep.index + 1].pathname,
                                });
                                goToNextStep({ previousTransactions: deal.data.saveEnquiryForm.paymentInfo });
                            }
                            else {
                                handleAsyncValidationErrors(deal.errors);
                            }
                            return [2 /*return*/];
                    }
                });
            }); });
        });
    }, [token, stateId]);
    return { isSubmitting: loading, onSubmit: onSubmit, error: error };
};
exports.default = useEnquiryFormSubmit;
